import React, { useState, useEffect } from 'react'
import AccordionComp from 'components/accordion/Accordion'
import Button from 'components/formElements/Button'
import DefaultSelect from 'components/formElements/DefaultSelect'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useRequest } from 'hooks/useRequest'
import Loading from 'components/loader/Loading'
//import useToast from 'hooks/useToast'
// import moment from 'moment'
// import { Calendar } from 'primereact/calendar'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
// import { ColumnGroup } from 'primereact/columngroup'
// import { Row } from 'primereact/row'
// import Loading from 'components/loader/Loading'
// import { useParams } from 'react-router-dom'
import * as FileSaver from 'file-saver'
const DeveloperPlanReport = () => {
	const [getProjects, loading] = useRequest()
	const [request] = useRequest()
	const [report, setReport] = useState([])
	//const [expandedRows, setExpandedRows] = useState([])
	//const { showToast } = useToast()
	//const [loading, setLoading] = useState(true)
	const [week, setWeek] = useState(4)
	const [departmentId, setDepartmentId] = useState(null)
	const [departments, setDepartments] = useState([])
	useEffect(() => {
		request('/Developer/GetDepartments', {
			method: 'GET',
		}).then((res) => {
			if (res.data.ok) {
				setDepartments(res.data.result.map((s) => ({ label: s.name, value: s.id })))
			}
		})
		handleSubmit()
	}, [])

	// const renderCheckbox = (rowData) => {
	// 	return <input type='checkbox' checked={rowData.includedProjectDevTeam} />
	// }

	const handleSubmit = () => {
		getProjects('/Developer/Report', { method: 'POST', data: { week: week, departmentId } }).then((res) => {
			if (res.data.ok) {
				//setExpandedRows([])
				setReport(
					res.data.result?.sort(function (a, b) {
						return a.developerName.localeCompare(b.developerName)
					})
				)
			}
		})
	}

	const rowBodyTemplate = (data) => {
		return {
			'bg-gray': data.includedProjectDevTeam === false && data.plannedDay != 0,
		}
	}

	const exportExcel = () => {
		import('xlsx').then((xlsx) => {
			const newArray = report.map(item => {
				const rest =  { developerName : item.developerName, projectName: item.projectName, 

					plannedDay: item.plannedDay, percent: item.percent } 
				return rest;
			});
			const workSheet = xlsx.utils.json_to_sheet(newArray)
			const workBook = { Sheets: { data: workSheet }, SheetNames: ['data'] }
			const excelBuffer = xlsx.write(workBook, {
				bookType: 'xlsx',
				type: 'array',
			})
			saveAsExcelFile(excelBuffer, 'developerPlanReport')
		})
	}

	const saveAsExcelFile = (buffer, fileName) => {

			let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
			let EXCEL_EXTENSION = '.xlsx'
			const data = new Blob([buffer], {
				type: EXCEL_TYPE,
			})
			FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION)
	
	}

	return (
		<AnimatedSpan className='page-container d-flex flex-column gap-4'>
			<div className='card'>
				<div className='row-margin-x'>
					<div className='col-md-6'>
						<div className='row'>
							<div className='col-md-2'>
								Hafta
								<input
									placeholder='Hafta'
									className='default-input'
									type='number'
									name='week'
									defaultValue={4}
									onChange={(e) => setWeek(e.target.value)}
								/>
							</div>
							<div className='col-md-4'>
								Departman
								<DefaultSelect
									isMulti={false}
									name='department'
									placeholder='Departmanlar'
									selectOptions={departments}
									handleChange={(e) => {
										if (e.value) setDepartmentId(e.value)
										else {
											setDepartmentId(null)
											return
										}
									}}
								/>
							</div>
							<div className='col-md-3 mt-3'>
								<Button disabled={loading} title='Raporu Al' handleClick={handleSubmit} className='btn-primary w-100 d-flex justify-content-center' />
							</div>
							<div className='col-md-3 mt-3'>
								<Button disabled={loading} title='Excel' handleClick={exportExcel} className='btn-success w-100 d-flex justify-content-center' />
							</div>
						</div>
					</div>
				</div>
			</div>
			{loading && (
				<div className='d-flex w-100 justify-content-center'>
					<Loading size={24} />
				</div>
			)}
			{report.length == 0 && !loading && (
				<div className='card'>
					<div className='text-sm text-semi-bold'>Gösterilecek Bir Veri Bulunmuyor</div>
				</div>
			)}
			<div className='row'>
				{report.length > 0 && (
					<AccordionComp className='report-accordion col-md-12' showHideTitle={false} onVal={false} title='Developer Plan Raporu'>
						<div className='row-margin-x'>
							<div className='col-md-12'>
								<DataTable
									emptyMessage='Hiç Kayıt Bulunamadı'
									responsiveLayout='stack'
									rowGroupMode='rowspan'
									groupRowsBy='developerName'
									value={report}
									style={{ lineHeight: '5px' }}
									sortField='developer' // Developer alanına göre sıralama yapılıyor
									sortOrder={1} // Artan sıralama için 1, azalan sıralama için -1
								>
									<Column
										sortable
										className='text-semi-bold text-bold '
										headerClassName='text-bold bg-primary text-default'
										field='developerName'
										style={{ width: 'auto' }}
										header='Developer'
									/>
									<Column
										sortable
										className='text-semi-bold text-sm '
										headerClassName='text-bold bg-primary text-default'
										field='projectName'
										style={{ width: 'auto' }}
										header='Proje'
										bodyClassName={rowBodyTemplate}
									/>
									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='plannedDay'
										style={{ width: 'auto' }}
										header='Planlanan Gün'
										bodyClassName={rowBodyTemplate}
									/>

									<Column
										sortable
										className='text-semi-bold text-sm'
										headerClassName='text-bold bg-primary text-default'
										field='percent'
										style={{ width: 'auto' }}
										header='Yüzde'
										body={(rowData) => {
											return <div>{'% ' + rowData.percent}</div>
										}}
										bodyClassName={rowBodyTemplate}
									/>
								</DataTable>
							</div>
						</div>
					</AccordionComp>
				)}
			</div>
		</AnimatedSpan>
	)
}

export default DeveloperPlanReport
